<template>
  <page-article
    :page-title="currentLecturesDetailsGetter.lecture_subject"
    :attachments="currentLecturesDetailsGetter.lecture_attachments"
  >
    <template>
      <div class="page_article_block col-12">
        <ul class="article_info_list">
          <li class="article_info_item">
            <span class="article_tag">主講人</span>{{ currentLecturesDetailsGetter.lecture_name }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">活動日期</span>
            {{ currentLecturesDetailsGetter.lecture_event_start_date || new Date() | moment("YYYY/MM/DD HH:mm") }} ~ {{ currentLecturesDetailsGetter.lecture_event_end_date || new Date() | moment("YYYY/MM/DD HH:mm") }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">報名日期</span>
            {{ currentLecturesDetailsGetter.lecture_start_date || new Date() | moment("YYYY/MM/DD HH:mm") }} ~ {{ currentLecturesDetailsGetter.lecture_end_date || new Date() | moment("YYYY/MM/DD HH:mm") }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">地點</span> {{ currentLecturesDetailsGetter.lecture_location }}
          </li>
          <li
            v-if="currentLecturesDetailsGetter.lecture_show_status"
            class="article_info_item"
          >
            <span class="article_tag">活動狀態</span>
            <span :style="check_full()">
              {{ currentLecturesDetailsGetter.lecture_students_count }}/{{ currentLecturesDetailsGetter.lecture_taker }}
            </span>(已報名/總名額)
          </li>
          <li class="article_info_item mb-5">
            <span class="article_tag">注意事項</span> {{ currentLecturesDetailsGetter.lecture_note }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">詳細內容</span>
          </li>
        </ul>
        <div
          class="article_content"
          v-html="currentLecturesDetailsGetter.lecture_content"
        />
        <div
          v-if="!isEnterpriseGetter"
          class="row justify-content-center"
        >
          <div class="col-md-3 col-sm-6">
            <button-wrapper
              v-if="!isExpired && !isStudentEnrolled && !notTimeYet"
              class="btn--fill"
              color="darken_blue"
              size="lg"
              @click="enrollLecture"
            >
              報名活動
            </button-wrapper>
            <button-wrapper
              v-else
              class="btn--fill"
              size="lg"
              disabled
            >
              {{ isStudentEnrolled ? '已報名活動' : notTimeYet ? '尚未開放報名' : '報名已截止' }}
            </button-wrapper>
          </div>
        </div>
      </div>
      <student-enroll-event-modal
        v-if="isOpenEnrollModal"
        :modal-title="`報名${currentLecturesDetailsGetter.lecture_subject}`"
        :is-modal-open="isOpenEnrollModal"
        :does-need-travel-accident-insurance="currentLecturesDetailsGetter.lecture_insurance_info"
        @modal:close="closeEnrollModal"
        @submit="submitEnrollment"
      />
      <redirect-login-page-modal
        v-if="isOpenRedirectModal"
        auth-type="student"
        :is-modal-open="isOpenRedirectModal"
        @modal:close="closeRedirectModal"
      />
    </template>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import PageArticle from '~components/pages/Article'
import ButtonWrapper from '~components/common/buttons'
import StudentEnrollEventModal from '~components/common/modal/StudentEnrollEvent'
import RedirectLoginPageModal from '~components/common/modal/RedirectLoginPage'
export default {
  name: 'LectureDetails',
  components: {
    PageArticle,
    ButtonWrapper,
    StudentEnrollEventModal,
    RedirectLoginPageModal
  },
  props: {
    lectureTypeEn: {
      type: String,
      default: ''
    },
    lectureType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpenEnrollModal: false,
      isOpenRedirectModal: false
    }
  },
  computed: {
    ...mapGetters('pages/lectures', [
      'currentLecturesDetailsGetter'
    ]),
    ...mapGetters('pages/students', [
      'isEnrolledCurrentCareerLectureGetter'
    ]),
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isStudentGetter'
    ]),
    isExpired () {
      return moment(this.currentLecturesDetailsGetter.lecture_end_date).isBefore(moment())
    },
    notTimeYet () {
      if (this.currentLecturesDetailsGetter.lecture_start_date) {
        return this.$moment().isBefore(this.$moment(this.currentLecturesDetailsGetter.lecture_start_date))
      }
      return true
    },
    isStudentEnrolled () {
      if (this.isStudentGetter) {
        return this.isEnrolledCurrentCareerLectureGetter(Number(this.$route.params.id))
      }
      return false
    }
  },
  async created () {
    try {
      await this.getLecturesDetailsById(this.$route.params.id)
    } catch (err) {
      this.$router.push(`/lectures/${this.lectureTypeEn}`)
    }
    if (this.isStudentGetter) {
      await this.getCareerLectureEnrolledRecords()
    }
  },
  methods: {
    ...mapActions('pages/lectures', [
      'getLecturesDetailsById'
    ]),
    ...mapActions('pages/students', [
      'createStudentCareerLectureEnrollment',
      'getCareerLectureEnrolledRecords'
    ]),
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    enrollLecture () {
      if (this.isStudentGetter) {
        if (this.currentLecturesDetailsGetter.lecture_join_link) {
          window.open(this.currentLecturesDetailsGetter.lecture_join_link, '_blank')
          return
        } else {
          this.isOpenEnrollModal = true
        }
      } else {
        // 尚未登入要先紀錄當前路由,稍後登入就可以處理了
        sessionStorage.setItem('route',window.location.href)
        this.isOpenRedirectModal = true
      }
      this.toggleModal(true)
    },
    closeEnrollModal () {
      this.isOpenEnrollModal = false
      this.toggleModal(false)
    },
    closeRedirectModal () {
      this.isOpenRedirectModal = false
      this.toggleModal(false)
    },
    async submitEnrollment (enrollment) {
      const request = { lecture_id: this.$route.params.id, ...enrollment }
      await this.createStudentCareerLectureEnrollment(request)
      await this.getCareerLectureEnrolledRecords()
      this.$router.push({
        path: '/students',
        query: {
          tab: '活動紀錄',
          sub: this.lectureType
        }
      })
    },
    check_full () {
      if (this.currentLecturesDetailsGetter.lecture_students_count >= this.currentLecturesDetailsGetter.lecture_taker) {
        return 'color: #f04b2d; margin-right: 8px;'
      }
      return 'color: #00ba09; margin-right: 8px;'
    }
  }
}
</script>
